(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_trust-badge"] && !Shopify.designMode) return;
  try {
    // On phones the warranty popover fills the screen and is the scrim, so a tap on it, outside its panel, is a click
  // on the popover itself rather than outside it: close it here (the pay later sheet does the same).
  document.addEventListener('click', (event) => {
    const sheet = event.target instanceof Element ? event.target.closest('.trust-badges__sheet') : null;
    if (sheet && event.target === sheet) sheet.hidePopover();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    /* Sticky mobile filter — detect stuck state for shadow */
  (function() {
    if (window.matchMedia('(min-width: 750px)').matches) return;

    const toggle = document.querySelector('[data-sticky-mobile-filter].facets-toggle');
    if (!toggle) return;

    const sentinel = document.createElement('div');
    sentinel.className = 'smf-sentinel';
    sentinel.setAttribute('aria-hidden', 'true');
    toggle.parentNode.insertBefore(sentinel, toggle);

    const observer = new IntersectionObserver(
      ([entry]) => {
        toggle.toggleAttribute('data-stuck', !entry.isIntersecting);
      },
      { threshold: 0, rootMargin: '-' + (parseFloat(getComputedStyle(toggle).top) || 60) + 'px 0px 0px 0px' }
    );
    observer.observe(sentinel);
  })();
  } catch(e) { console.error(e); }
})();

})();
